import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, FormControl, MenuItem, Select, TextField, Button, TablePagination, FormControlLabel, Checkbox, Pagination, Skeleton } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'
import StockContext from './services/stockApi'
import { useSelector } from 'react-redux'
import { STOCK_CONFIG } from './config'
import Swal from 'sweetalert2'
import './reserve.scss'
import { getData, postData, putData } from '../../services/api'
export default function Reserve() {
    // const [checked, setChecked] = useState(false)
    // const { getReservesSeedList, getReservesSeedAllBranchList } = useContext(StockContext);
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let c = searchParams.get('c') || ''
    let checked = searchParams.get('checked') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || ''
    // const [q, setQ] = useState('')
    // const [catalogNo, setCatalogNo] = useState('all')
    const [catalog, setCatalog] = useState([])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);
    const [rowsPerPage] = useState(10);
    const { profile } = useSelector(state => state.profile)

    const getItemcatalogs = async () => {
        const res = await api.get(`dbms/itemcatalogs`)
        const data = await res.data.result
        if (res.data.status === true) {
            setCatalog(data)
        }
    }
    useEffect(() => {
        getItemcatalogs()
    }, [])
    const getReservesSeedList = async () => {
        setLoading(true)
        let _params = `${q ? '&q=' + q : ''}${c ? c !== 'all' ? '&catalogNo=' + c : '' : ''}`

        await getData(STOCK_CONFIG.requests.getReserves.url + `?page=${page}&limit=${rowsPerPage}`, _params).then((response) => {
            if (response.status === true) {
                setData(response.result)
                setLoading(false)
            }
        })
    }
    const getReservesSeedAllBranchList = async () => {
        setLoading(true)
        let _params = `?${q ? 'q=' + q + '&' : ''}${c ? c !== 'all' ? 'catalogNo=' + c : '' : ''}`

        await getData(STOCK_CONFIG.requests.getNonCenterReserves.url + `?page=${page}&limit=${rowsPerPage}`, _params).then((response) => {
            if (response.status === true) {
                setData(response.result)
                setLoading(false)
            }
        })
    }
    useEffect(() => {
        if (checked === 'true') {
            getReservesSeedAllBranchList(q, c, setData)
        } else {
            getReservesSeedList(q, c, setData)
        }
    }, [q, c, checked, page])
    function checkReserveCenter(reserve) {
        const ReserveNoCenter = reserve?.ReserveNo.split('-');
        return ReserveNoCenter.length > 1 ? true : false
    }

    const reserveAdd = async (body) => {

        if (body?.ReserveNo) {
            const url = STOCK_CONFIG.requests.getReserves.url + `/${body?.ReserveNo}`;
            await putData(url, body).then((response) => {
                if (response.status === true) {
                    Swal.fire(
                        'เรียบร้อย',
                        '',
                        'success'
                    )
                    if (checked === 'true') {
                        getReservesSeedAllBranchList(q, c, setData)
                    } else {
                        getReservesSeedList(q, c, setData)
                    }
                }
            })
        } else {
            await postData(STOCK_CONFIG.requests.getReserves.url, body).then((response) => {
                if (response.status === true) {
                    Swal.fire(
                        'เรียบร้อย',
                        '',
                        'success'
                    )
                }
            })
        }

    }

    async function Close(ReserveNo, RefNo) {
        Swal.fire({
            title: `ยืนยันการยกเลิก: ${RefNo}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4ab866',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                const body = {
                    ReserveNo: ReserveNo,
                    Status: 'C'
                }
                reserveAdd(body)
            }
        })

    }

    return (
        <Page>
            <div class="container-fluid">

                <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0px' }}>
                    <div class="col-lg-3 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการสำรองเมล็ดพันธุ์
                        </label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                        {profile?.BranchNo?.BranchNo !== '00' && <>
                            <div class="col-lg-2 col-md-6 d-flex align-items-center">
                                <FormControlLabel control={<Checkbox checked={checked === 'true' ? true : false} onChange={e => setSearchParams({ q: q, c: c, checked: `${e.target.checked}` })} />} label="แสดงรายการของศูนย์เมล็ดพันธุ์ทั้งหมด" />
                            </div>
                            <div class="col-lg-2 col-md-12 text-center">
                                <Link to='/stock/reserve/add'>
                                    <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                                </Link>
                            </div>
                        </>}
                        <div class="col-lg-2 col-md-6">
                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={c || 'all'} onChange={e => setSearchParams({ q: q, c: e.target.value, checked: checked })} 
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                    >
                                        <MenuItem value='all'>ทุกพันธุ์ข้าว</MenuItem>
                                        {catalog?.map((x) => <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Box>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <Box className='backgroundField'>
                                <TextField value={q} onChange={e => setSearchParams({ q: e.target.value, c: c, checked: checked })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                    InputProps={{
                                        disableUnderline: true,
                                        startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </div>

                <div class="reserve row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover " >
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-center">ที่</th>
                                    <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                    <th class="text-center">ผู้สำรอง</th>
                                    <th class="text-center">เลขที่หนังสือ</th>
                                    <th class="text-center">ลงวันที่</th>

                                    <th class="text-center">จังหวัด</th>
                                    <th class="text-center">อำเภอ</th>
                                    <th class="text-center">ชื่อโครงการ</th>

                                    <th class="text-center">ปริมาณ (กิโลกรัม)</th>
                                    <th class="text-center">สถานะ</th>
                                    <th class="text-center">ขาย</th>
                                    <th class="text-center">ดำเนินการ</th>


                                </tr>
                            </thead>
                            <tbody class="">
                                {data?.items?.map((x, i) => (
                                    <tr className={id === x?.ReserveNo ? 'active' : ''}>
                                        <td style={{ color: 'limegreen' }}>
                                            {x?.SaleStatus === 'N' && (profile?.BranchNo?.BranchNo === x?.BranchNo?.BranchNo) ? <span>NEW!</span> : ''}
                                        </td>
                                        <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                        <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                        <td class="text-center">{x?.CustomerNo?.ContactName}</td>
                                        <td class="text-center">{x?.RefNo}</td>
                                        <td class="text-center">{dayjs(x?.DocumentDate).format('DD/MM/BBBB')}</td>
                                        <td class="text-center">{x?.Province}</td>
                                        <td class="text-center">{x?.District}</td>
                                        <td class="text-center">{x?.CampaignName}</td>
                                        <td class="text-center">{x?.TotalQty.toLocaleString()}</td>
                                        <td class="text-center">
                                            {x?.Status === 'Y' ?
                                                <span class="status-active">
                                                    ปกติ
                                                </span> : x?.Status === 'N' ?
                                                    <span class="status-inactive">
                                                        ยกเลิก
                                                    </span> : x?.Status === 'D' ?
                                                        <span class="status-active">
                                                            เสร็จสิ้น
                                                        </span> : x?.Status === 'C' ?
                                                            <span class="status-draft">
                                                                ปิด
                                                            </span> : ''
                                            }
                                        </td>
                                        <td class="text-center">
                                            {x.SaleStatus === 'P' &&
                                                <span class="status-inactive">
                                                    ขายไปบางส่วน
                                                </span>}
                                        </td>
                                        <td class="text-center">
                                            <Link to={`/stock/reserve/${x?.ReserveNo}`}>
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }} onClick={() => setSearchParams({ id: x?.ReserveNo, page: page, q: q, c: c, checked: checked, })}>เรียกดู</Button>
                                            </Link>
                                            {(x?.Status === 'Y') && (profile?.BranchNo?.BranchNo === x?.BranchNo?.BranchNo) && !checkReserveCenter(x) &&
                                                <Button onClick={() => Close(x?.ReserveNo, x?.RefNo)} variant='contained' color='error' sx={{ marginLeft: '10px' }}>ปิด</Button>

                                            }
                                            {(x?.Status === 'Y') && (profile?.BranchNo?.BranchNo === '00') && checkReserveCenter(x) &&
                                                <Button onClick={() => Close(x?.ReserveNo, x?.RefNo)} variant='contained' color='error' sx={{ marginLeft: '10px' }}>ปิด</Button>

                                            }
                                        </td>
                                    </tr>
                                ))}


                            </tbody>
                        </table>
                    </div>}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, c: c, checked: checked, id })} shape="rounded" />
                    </div>
                </div>
            </div>
        </Page>
    )
}
